import { useEffect } from 'react'
import {
  Wrapper,
  Overlay,
  Card,
  Content,
  EllipseWrapper
} from './styles'
import ImageEllipse from '../../ellipses/image_ellipse'
import { Box } from '../../ui/components'
import { SimpleButton } from '../../ui/components/buttons/simple'
import { t } from '../../../adapters/translate/translate'
import { replaceHtmlEntity } from '../../../utils/text_replace'

type Props = {
  content: string;
  url: string;
  onAction?: () => void;
}

const InstructionModal = ({ content, url, onAction }: Props) => {
  useEffect(() => {
    const div = document.getElementById('modalInstructions')
    if (div) {
      div.innerHTML = replaceHtmlEntity(div.innerHTML)
    }
  }, [])

  return (
    <Wrapper>
      <Overlay onClick={onAction}/>
      <Card>
        <EllipseWrapper>
          <ImageEllipse url={url}/>
        </EllipseWrapper>

        <Content>
          <div id="modalInstructions" dangerouslySetInnerHTML={{ __html: content }}></div>
        </Content>

        <Box w={'363px'} mt="35px">
          <SimpleButton
            onAction={onAction}
            color={'#606060'}
            hasAnimation={false}
            disabled={false}
          >
           {t('Close')}
          </SimpleButton>
        </Box>
      </Card>
    </Wrapper>
  )
}

export default InstructionModal
